import { useEffect } from "react";

import { APP_NAME } from "../lib/appName";

/**
 * Compose a tab title, most specific segment first: `"Settings · tinsmith/api -
 * Tinsmith"`. A narrow tab ellipsizes the *end* of its label, so what identifies
 * the page leads and the product name trails. Segments that are blank or not
 * loaded yet drop out; with nothing left the title is the bare product name.
 */
export const formatDocumentTitle = (
  segments: ReadonlyArray<string | undefined>,
): string => {
  const named = segments
    .map((segment) => segment?.trim())
    .filter((segment): segment is string => Boolean(segment));
  return named.length > 0 ? `${named.join(" · ")} - ${APP_NAME}` : APP_NAME;
};

/**
 * Name the browser tab after the page you're on. People keep a Tinsmith tab open
 * per task, so the tab strip doubles as their task list and every route owns a
 * title (`App.test.tsx` holds each one to it). A page whose name is still
 * loading passes `undefined` rather than leaving the previous page's title up.
 */
export const useDocumentTitle = (
  ...segments: ReadonlyArray<string | undefined>
): void => {
  const title = formatDocumentTitle(segments);
  useEffect(() => {
    document.title = title;
  }, [title]);
};
